/**
 * Applies podcast_lp_discount.code after cart/add on matching LPs.
 * Uses the fetch captured at load (native) so cart/update.js is invisible to
 * cart-drawer.js — going through window.fetch retriggers gift-sync → add →
 * update in a loop and never reaches checkout.
 */
(function () {
  const cfg = window.__podcastLpDiscount;
  const code = String((cfg && cfg.code) || '').trim();
  if (!code) return;

  const nativeFetch = window.fetch.bind(window);
  let applying = null;
  let applied = false;

  function applyDiscount() {
    if (applied) return Promise.resolve();
    if (applying) return applying;
    applying = nativeFetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code }),
    })
      .then(function (res) {
        if (res.ok) applied = true;
      })
      .catch(function () {})
      .then(function () {
        applying = null;
      });
    return applying;
  }

  function hrefOf(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function isCartAdd(url) {
    return /\/cart\/add(\.js)?(\?|$)/.test(String(url || ''));
  }

  window.fetch = function (input) {
    const url = hrefOf(input);
    const req = nativeFetch.apply(this, arguments);
    if (!isCartAdd(url) || window.__cartDrawerUpdating) return req;
    return req.then(function (res) {
      if (!res.ok) return res;
      return applyDiscount().then(function () {
        return res;
      });
    });
  };

  const origOpen = XMLHttpRequest.prototype.open;
  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__podcastLpUrl = url;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (isCartAdd(this.__podcastLpUrl) && !window.__cartDrawerUpdating) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) applyDiscount();
      });
    }
    return origSend.apply(this, arguments);
  };
})();
